import { render, staticRenderFns } from "./FormDatasA.vue?vue&type=template&id=029bc188&"
import script from "./FormDatasA.vue?vue&type=script&lang=js&"
export * from "./FormDatasA.vue?vue&type=script&lang=js&"
import style0 from "./FormDatasA.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports